export default __webpack_public_path__ + "static/media/flag-bermuda.d4533d21.svg";